<template>
  <div>
    <!-- Title -->
    <h3 class="mb-6 text-center text-lg font-medium text-gray-600">
      Mándanos un WhatsApp
    </h3>

    <!-- Phones -->
    <div class="grid grid-cols-1 gap-4">
      <div
        v-for="phone in phones"
        :key="phone.id"
        class="text-center"
      >
        <a
          :href="`https://wa.me/${phone.tel}?text=Hola, les contacto para que me indiquen el precio del oro hoy, muchas gracias`"
          target="_blank"
          class="
    block rounded-lg
    border border-solid border-gray-300 bg-white
    py-3 text-base text-gray-700
    transition-shadow duration-200
    hover:border-gray-400
    hover:shadow-lg
  "
        >
          {{ phone.display }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

export interface PhoneItem {
  id: string
  label: string
  display: string
  tel: string
}

defineProps<{
  phones: PhoneItem[]
}>()

defineEmits<{
  (e: 'back'): void
}>()
</script>
